module.exports = __webpack_public_path__ + "img/instagram-icon.87272ab4.svg";